import React from "react";
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import "./WithdrawUnavailabilityModal.scss";

export const WithdrawUnavailabilityModal = ({
  show,
  record,
  onClose,
  onConfirm,
  isWithdrawing = false,
  error = "",
}) => (
  <MotifModal
    show={show}
    onClose={onClose}
    size="md"
    className="laap-withdraw-modal"
  >
    <MotifModalHeader>Withdraw Unavailability</MotifModalHeader>
    <MotifModalBody>
      <p className="laap-withdraw-message">
        Are you sure you want to withdraw this unavailability request?
      </p>

      <div className="laap-withdraw-details">
        <div className="laap-withdraw-detail">
          <span className="laap-withdraw-label">Name</span>
          <span className="laap-withdraw-value">{record?.name || ""}</span>
          <span className="laap-withdraw-email">{record?.email || ""}</span>
        </div>
        <div className="laap-withdraw-detail">
          <span className="laap-withdraw-label">Leave Dates</span>
          <span className="laap-withdraw-value">{record?.dates || ""}</span>
        </div>
        <div className="laap-withdraw-detail">
          <span className="laap-withdraw-label">Reason</span>
          <span className="laap-withdraw-value">{record?.reason || "-"}</span>
        </div>
      </div>

      {error && (
        <span className="laap-withdraw-error" role="alert">
          {error}
        </span>
      )}
    </MotifModalBody>
    <MotifModalFooter>
      <div className="laap-withdraw-footer-actions">
        <button
          type="button"
          className="laap-withdraw-cancel"
          onClick={onClose}
          disabled={isWithdrawing}
        >
          Cancel
        </button>
        <button
          type="button"
          className="laap-withdraw-confirm"
          onClick={() => onConfirm(record)}
          disabled={isWithdrawing}
        >
          {isWithdrawing ? "Withdrawing..." : "Withdraw"}
        </button>
      </div>
    </MotifModalFooter>
  </MotifModal>
);

export default WithdrawUnavailabilityModal;
